// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Group } from './group';
import { MessageAttachment } from './message-attachment';
import { MessageSent } from './message-sent';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Message extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  bcc?: string;
  body?: string;
  cc?: string;
  created!: Date;
  deleted?: Date;
  fromUserId?: number;
  privateEmail!: boolean;
  sent?: Date;
  status!: number;
  subject?: string;
  toGroupId?: string;
  attachments!: MessageAttachment[];
  fromUser!: User;
  sentLog!: MessageSent[];
  toGroup!: Group;
}

